import { Component, Field } from '@contember/interface'

export const ProductPreview = Component(() => (
	<div>
		<Field field="name" />
	</div>
))
